export const QUERY_KEYS = {
  devices: ['devices'] as const,
  device: (id: string) => ['devices', id] as const,
  devicePings: (id: string) => ['devices', id, 'pings'] as const,
  deviceCommands: (id: string) => ['devices', id, 'commands'] as const,
  pings: ['pings'] as const,
  dashboardStats: ['dashboard', 'stats'] as const,
}

export const STALE_TIME = {
  default: 30_000,
  devices: 15_000,
  dashboard: 60_000,
}

export const ROUTES = {
  dashboard: '/device-ops/dashboard',
  devices: '/device-ops',
  deviceDetails: (id: string) => `/device-ops/${id}`,
}
